export default __webpack_public_path__ + "static/media/generate.56af076d.svg";